import { FC } from 'react'
import cls from 'classnames'

import styles from './Item.module.scss'

export const Item: FC<PropsWithClassName> = ({ children, className }) => (
  <div className={cls(styles.root, className)}>{children}</div>
)
